import styled from "styled-components";

export const Content = styled.div`
    flex: 1;
    min-height: 0;
    min-width: 0;
    width: 100%;
    margin-top: 0;
    overflow-x: hidden;
    overflow-y: auto;
    font-family: 'Inter', sans-serif;

    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    ::-webkit-scrollbar-track {
        background: #c0c0c0;
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #ffffff;
        border-radius: 10px;
        border: 2px solid #c0c0c0;
    }
`;
